/* Atelier Hub Portugal — workshop product page (combined variant picker, gallery, tabs) */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ahp-pdp').forEach(initWorkshopProduct);
});

function initWorkshopProduct(root) {
  var dataEl = root.querySelector('.ahp-pdp-variants-json');
  if (!dataEl) return;

  var variants = JSON.parse(dataEl.textContent || '[]');
  var optionCount = variants.length ? variants[0].options.length : 0;
  // Nothing pre-selected — the shopper must actively choose every option
  // before a variant is considered selected.
  var selections = new Array(optionCount).fill(null);

  var variantIdInput = root.querySelector('[data-ahp-variant-id]');
  var priceEl = root.querySelector('[data-ahp-price]');
  var comparePriceEl = root.querySelector('[data-ahp-compare-price]');
  var addButton = root.querySelector('[data-ahp-add-button]');
  var addButtonLabel = addButton ? addButton.querySelector('[data-ahp-add-label]') : null;
  var addButtonPrice = addButton ? addButton.querySelector('[data-ahp-add-price]') : null;
  var mainImage = root.querySelector('[data-ahp-main-image]');
  var defaultAddLabel = addButton ? addButton.getAttribute('data-ahp-default-label') : '';

  // Shows a price as soon as a lamp style is picked, even before the
  // date/time has also been chosen — the style alone determines price.
  function showStylePrice(priceText) {
    if (!priceText) return;
    if (priceEl) priceEl.textContent = priceText;
    if (addButtonPrice) {
      addButtonPrice.textContent = priceText;
      addButtonPrice.hidden = false;
    }
  }

  function findVariant() {
    if (selections.indexOf(null) !== -1) return undefined;
    return variants.find(function (variant) {
      return variant.options.every(function (value, i) { return selections[i] === value; });
    });
  }

  function updateStyleAvailability() {
    root.querySelectorAll('[data-ahp-style]').forEach(function (swatch) {
      var styleValue = swatch.getAttribute('data-ahp-style');
      var styleIndex = parseInt(swatch.getAttribute('data-ahp-style-index'), 10);
      var matches = variants.filter(function (variant) {
        return variant.options[styleIndex] === styleValue && variant.options.every(function (value, i) {
          return i === styleIndex || selections[i] === null || selections[i] === value;
        });
      });
      var anyAvailable = matches.some(function (v) { return v.available; });
      swatch.classList.toggle('ahp-pdp-swatch--unavailable', matches.length > 0 && !anyAvailable);
    });
  }

  function render() {
    var matched = findVariant();
    updateStyleAvailability();

    if (!matched) {
      if (addButton) addButton.disabled = true;
      if (addButtonLabel) addButtonLabel.textContent = 'Selecione as opções';
      return;
    }

    if (variantIdInput) variantIdInput.value = matched.id;
    if (priceEl) priceEl.textContent = matched.price_html;
    if (comparePriceEl) {
      if (matched.compare_at_price_html) {
        comparePriceEl.textContent = matched.compare_at_price_html;
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.hidden = true;
      }
    }
    if (mainImage && matched.image) {
      mainImage.src = matched.image;
    }

    if (addButton) {
      addButton.disabled = !matched.available;
      if (addButtonLabel) addButtonLabel.textContent = matched.available ? defaultAddLabel : 'Esgotado';
    }
    if (addButtonPrice) {
      addButtonPrice.textContent = matched.price_html;
      addButtonPrice.hidden = false;
    }
  }

  // Date/Hora dropdown
  var dropdown = root.querySelector('[data-ahp-dropdown]');
  var dropdownTrigger = root.querySelector('[data-ahp-dropdown-trigger]');
  var dropdownPanel = root.querySelector('[data-ahp-dropdown-panel]');
  var dropdownLabel = root.querySelector('[data-ahp-dropdown-label]');

  function closeDropdown() {
    if (!dropdown || !dropdownPanel) return;
    dropdownPanel.hidden = true;
    dropdown.setAttribute('data-open', 'false');
    if (dropdownTrigger) dropdownTrigger.setAttribute('aria-expanded', 'false');
  }

  function openDropdown() {
    if (!dropdown || !dropdownPanel) return;
    dropdownPanel.hidden = false;
    dropdown.setAttribute('data-open', 'true');
    if (dropdownTrigger) dropdownTrigger.setAttribute('aria-expanded', 'true');
  }

  if (dropdownTrigger && dropdownPanel) {
    dropdownTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (dropdownPanel.hidden) openDropdown(); else closeDropdown();
    });
    document.addEventListener('click', function (e) {
      if (dropdown && !dropdown.contains(e.target)) closeDropdown();
    });
  }

  root.querySelectorAll('[data-ahp-pill]').forEach(function (pill) {
    pill.addEventListener('click', function () {
      root.querySelectorAll('[data-ahp-pill]').forEach(function (p) { p.classList.remove('ahp-pdp-dropdown__option--active'); });
      pill.classList.add('ahp-pdp-dropdown__option--active');
      var indices = pill.getAttribute('data-ahp-indices').split(',').map(Number);
      var values = pill.getAttribute('data-ahp-values').split('');
      indices.forEach(function (idx, i) { selections[idx] = values[i]; });

      if (dropdownLabel) dropdownLabel.textContent = pill.textContent.trim();
      if (dropdownTrigger) dropdownTrigger.classList.add('ahp-pdp-dropdown__trigger--selected');
      closeDropdown();

      render();
    });
  });

  // Set the dropdown's initial label/state from the pre-selected option.
  if (dropdownLabel) {
    var activeOption = root.querySelector('.ahp-pdp-dropdown__option--active');
    if (activeOption) {
      dropdownLabel.textContent = activeOption.textContent.trim();
      if (dropdownTrigger) dropdownTrigger.classList.add('ahp-pdp-dropdown__trigger--selected');
    }
  }

  root.querySelectorAll('[data-ahp-style]').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      root.querySelectorAll('[data-ahp-style]').forEach(function (s) { s.classList.remove('ahp-pdp-swatch--active'); });
      swatch.classList.add('ahp-pdp-swatch--active');
      var idx = parseInt(swatch.getAttribute('data-ahp-style-index'), 10);
      selections[idx] = swatch.getAttribute('data-ahp-style');
      var swatchPriceEl = swatch.querySelector('.ahp-pdp-swatch__price');
      if (swatchPriceEl) showStylePrice(swatchPriceEl.textContent.trim());
      render();
    });
  });

  root.querySelectorAll('[data-ahp-native-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var idx = parseInt(select.getAttribute('data-ahp-option-index'), 10);
      selections[idx] = select.value;
      render();
    });
  });

  // Style swatch row — arrows overlaid on the images, fully hidden (not
  // just dimmed) at whichever end there's nothing left to scroll to.
  (function () {
    var row = root.querySelector('[data-ahp-swatch-row]');
    var prev = root.querySelector('[data-ahp-swatch-scroll-prev]');
    var next = root.querySelector('[data-ahp-swatch-scroll-next]');
    if (!row || !prev || !next) return;

    var updateArrows = function () {
      var hasOverflow = row.scrollWidth - row.clientWidth > 4;
      var atStart = row.scrollLeft <= 4;
      var atEnd = row.scrollLeft >= row.scrollWidth - row.clientWidth - 4;
      prev.classList.toggle('ahp-pdp-scroll-arrow--is-hidden', !hasOverflow || atStart);
      next.classList.toggle('ahp-pdp-scroll-arrow--is-hidden', !hasOverflow || atEnd);
    };

    var step = function () {
      var swatch = row.querySelector('[data-ahp-style]');
      return swatch ? swatch.offsetWidth + 12 : 180;
    };

    prev.addEventListener('click', function () { row.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    row.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
    setTimeout(updateArrows, 150);
  })();

  // Quantity stepper
  var qtyInput = root.querySelector('[data-ahp-qty-input]');
  var qtyMinus = root.querySelector('[data-ahp-qty-minus]');
  var qtyPlus = root.querySelector('[data-ahp-qty-plus]');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });
  }

  // Gallery thumbnails
  root.querySelectorAll('[data-ahp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      root.querySelectorAll('[data-ahp-thumb]').forEach(function (t) { t.classList.remove('ahp-pdp-thumb--active'); });
      thumb.classList.add('ahp-pdp-thumb--active');
      if (mainImage) mainImage.src = thumb.getAttribute('data-ahp-full');
    });
  });

  // Gallery thumbnails — fit as many whole thumbnails as possible inside
  // the main image's height (never cut one in half), then fade + arrows
  // at top/bottom to reveal the rest when scrolled.
  var thumbsWrap = root.querySelector('.ahp-pdp-gallery__thumbs-wrap');
  var thumbsList = root.querySelector('[data-ahp-thumbs]');
  var thumbsMore = root.querySelector('[data-ahp-thumbs-more]');
  var thumbsPrev = root.querySelector('[data-ahp-thumbs-prev]');
  var galleryMain = root.querySelector('.ahp-pdp-gallery__main');

  if (thumbsWrap && thumbsList && thumbsMore) {
    var matchThumbsHeight = function () {
      if (!galleryMain) return;
      var mainHeight = galleryMain.offsetHeight;
      if (!mainHeight) return;
      var thumb = thumbsList.querySelector('[data-ahp-thumb]');
      var thumbHeight = thumb ? thumb.offsetHeight : 88;
      var gap = 10;
      var visibleCount = Math.floor((mainHeight + gap) / (thumbHeight + gap));
      if (visibleCount < 1) visibleCount = 1;
      var target = (visibleCount * thumbHeight) + ((visibleCount - 1) * gap);
      thumbsList.style.maxHeight = target + 'px';
    };

    var updateThumbsOverflow = function () {
      var hasMoreBelow = thumbsList.scrollHeight - thumbsList.clientHeight - thumbsList.scrollTop > 4;
      var hasMoreAbove = thumbsList.scrollTop > 4;
      thumbsWrap.classList.toggle('ahp-pdp-gallery__thumbs-wrap--overflowing', hasMoreBelow);
      thumbsWrap.classList.toggle('ahp-pdp-gallery__thumbs-wrap--scrolled', hasMoreAbove);
    };

    var refreshThumbsLayout = function () {
      matchThumbsHeight();
      updateThumbsOverflow();
    };

    thumbsMore.addEventListener('click', function () {
      var thumb = thumbsList.querySelector('[data-ahp-thumb]');
      var step = thumb ? thumb.offsetHeight + 10 : 100;
      thumbsList.scrollBy({ top: step * 2, behavior: 'smooth' });
    });
    if (thumbsPrev) {
      thumbsPrev.addEventListener('click', function () {
        var thumb = thumbsList.querySelector('[data-ahp-thumb]');
        var step = thumb ? thumb.offsetHeight + 10 : 100;
        thumbsList.scrollBy({ top: -(step * 2), behavior: 'smooth' });
      });
    }
    thumbsList.addEventListener('scroll', updateThumbsOverflow);
    window.addEventListener('resize', refreshThumbsLayout);
    if (mainImage) mainImage.addEventListener('load', refreshThumbsLayout);
    refreshThumbsLayout();
    // Fonts/images can still shift layout after first paint.
    setTimeout(refreshThumbsLayout, 150);
  }

  // Tabs
  root.querySelectorAll('[data-ahp-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      root.querySelectorAll('[data-ahp-tab]').forEach(function (t) {
        t.classList.remove('ahp-pdp-tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      root.querySelectorAll('[data-ahp-tab-panel]').forEach(function (p) { p.hidden = true; });
      tab.classList.add('ahp-pdp-tab--active');
      tab.setAttribute('aria-selected', 'true');
      var panel = root.querySelector('[data-ahp-tab-panel="' + tab.getAttribute('data-ahp-tab') + '"]');
      if (panel) panel.hidden = false;
    });
  });

  render();
}
